export const INITIAL_ON_EDIT_FAQ = {
  channelId: '',
  faqTitle: '',
  faqId: '',
  faqDescription: '',
  isFAQEnabled: true,
  loading: false,
  questions: [],
};
